import React from 'react';
import { createRoot } from 'react-dom/client';
import { Proveedor } from './estado.jsx';
import App from './App.jsx';
import './estilos.css';

createRoot(document.getElementById('raiz')).render(
  <React.StrictMode>
    <Proveedor><App /></Proveedor>
  </React.StrictMode>,
);
